/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { NumericTextBox } from "@progress/kendo-react-inputs";

export default function NumericInput({
  label,
  rules,
  name,
  isRequired,
  info,
  disabled,
  errors,
  control,
  inputProps,
}) {
  return (
    <FormControl isRequired={Boolean(isRequired)}>
      <FormLabel>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => {
          return (
            <NumericTextBox
              {...inputProps}
              className={
                errors[name]
                  ? `error-field ${inputProps?.className || ""}`
                  : `${inputProps?.className || ""}`
              }
              disabled={disabled}
              value={field.value || null}
              onChange={(e) => {
                field.onChange(e.value);
              }}
            />
          );
        }}
      />
      {info ? (
        <p className="text-sm text-gray-500 mt-1 italic">{info || ""}</p>
      ) : (
        <></>
      )}
      {errors ? (
        errors[name] ? (
          <p className="text-sm text-red-500 mt-1">
            {errors[name].message || "Please Select Date!"}
          </p>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </FormControl>
  );
}
